<template>
    <div>
      <VistaPreviaPdf v-if="pdfUrl" :rutaArchivo="pdfUrl" />
    </div>
</template>
<script>
import VistaPreviaPdf from '@/components/VistaPreviaPdf.vue';
import mixAuditorias from './mixAuditorias';

export default {
  props: {
    rutaArchivo: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      pdfUrl: null,
    };
  },
  mixins: [mixAuditorias],
  components: {
    VistaPreviaPdf,
  },
  mounted() {
    this.loadPdfFile();
  },
  methods: {
    async loadPdfFile() {
      const parseFile = JSON.parse(this.rutaArchivo);
      const { data, err } = await this.mixGetPdf(parseFile.public_key);

      if (err) {
        console.log(err);
        return;
      }

      this.pdfUrl = URL.createObjectURL(new Blob([data], {
        type: 'application/pdf',
      }));
    },
  },
};
</script>
